import {
  CheckboxField,
  MultipleSelectField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row, Tooltip } from "reactstrap"
import { Field, getFormSyncErrors, isDirty, reset } from "redux-form"

const AccessTab = ({
  metaTags,
  isDirty,
  resetForm,
  tabIsActive,
  handleSave,
  formSyncErrors,
  isTPProduct,
}) => {
  const TAG_EXPIRE_TYPES = [
    {
      label: "hours",
      value: 1,
    },
    {
      label: "days",
      value: 2,
    },
    {
      label: "weeks",
      value: 3,
    },
    {
      label: "months",
      value: 4,
    },
  ]

  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (
      !tabIsActive &&
      isDirty &&
      (!formSyncErrors || Object?.keys(formSyncErrors)?.length === 0)
    ) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>ACCESS</h4>
        </CardHeader>
        <CardBody>
          <Row className="mb-3">
            <Col xl={6}>
              <Field
                name="accessTags"
                placeholder="Enter Tag"
                label="Limit access to tags (only users with one of the tags can
                    purchase the product):"
                component={MultipleSelectField}
                options={metaTags?.map(tag => ({
                  label: tag?.tag,
                  value: tag?.id,
                }))}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <Field
                name="adminTags"
                placeholder="Enter Tag"
                label="Admin Tags"
                component={MultipleSelectField}
                options={metaTags?.map(tag => ({
                  label: tag?.tag,
                  value: tag?.id,
                }))}
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col xs="auto" style={{ minWidth: "fit-content" }} className="mt-2">
              <label>
                Admin Tag Removed After:&nbsp;
                <i className="fas fa-question-circle" id="productTagAccess"></i>
                &nbsp;
              </label>
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target="productTagAccess"
                toggle={toggle}
              >
                <span>
                  The amount of time after which the admin tag will be removed
                  from the users.
                </span>
                <br />
                <span>
                  It's calculated starting from when the user has paid for the
                  product.
                </span>
              </Tooltip>
            </Col>
            <Col xs="auto">
              <Field
                name="tagExpireNumber"
                component={TextField}
                type="number"
                min="0"
              />
            </Col>
            <Col xs="auto">
              <div style={{ minWidth: "140px" }}>
                <Field
                  name="tagExpireType"
                  component={SingleSelectField}
                  options={TAG_EXPIRE_TYPES}
                  placeholder="Select Type"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <Field
                name="removeTags"
                placeholder="Enter Tag"
                label="Remove Tags"
                component={MultipleSelectField}
                options={metaTags?.map(tag => ({
                  label: tag?.tag,
                  value: tag?.id,
                }))}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xl={6}>
              <Field
                name="userTagLabel"
                component={TextField}
                label="Label for user tags drop down (displayed in order form)"
              />
            </Col>
          </Row>
          {!isTPProduct && (
            <React.Fragment>
              <Row className="mt-4">
                <Col xl={6}>
                  <Field
                    name="userTags"
                    placeholder="Enter Tag"
                    label="User Tags"
                    component={MultipleSelectField}
                    options={metaTags?.map(tag => ({
                      label: tag?.tag,
                      value: tag?.id,
                    }))}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs="auto">
                  <Field
                    name="selectOne"
                    component={CheckboxField}
                    label="Select One Only"
                  />
                </Col>
              </Row>
            </React.Fragment>
          )}
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  metaTags: state.Tags.metaTags,
  isDirty: isDirty(FORM_NAMES.PRODUCT)(state, ...["access"]),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.PRODUCT)(state),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.PRODUCT)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AccessTab)
